
import axios from 'axios';
import moment from 'moment';


export const BINDING_SEARCH_TIME_START = '09:00';
export const BINDING_SEARCH_TIME_END = '22:00';


export function getDayBindingSearchParams(date) {
  const day = date.format('YYYY-MM-DD');
  return {
    date_start: day,
    time_start: BINDING_SEARCH_TIME_START,
    date_end: day,
    time_end: BINDING_SEARCH_TIME_END,
  };
}


export function getOrderBindingSearchParams(order, fallbackDate) {
  if (order && order.date_start) {
    const params = {
      date_start: moment(order.date_start).format('YYYY-MM-DD'),
      time_start: moment(order.date_start).format('HH:mm'),
    };
    if (order.date_end) {
      params.date_end = moment(order.date_end).format('YYYY-MM-DD');
      params.time_end = moment(order.date_end).format('HH:mm');
    }
    if (order.cargo_weight && parseInt(order.cargo_weight, 10)) {
      params.cargo_weight = parseInt(order.cargo_weight, 10);
    }
    return params;
  }
  if (fallbackDate) {
    return getDayBindingSearchParams(fallbackDate);
  }
  return null;
}


export function searchBindings(params) {
  return axios.get('timetable_slot/search', { params }).then(res => res.data || []);
}


export function getBindingSlot(vehicle) {
  return vehicle && vehicle.start_slot ? vehicle.start_slot : vehicle;
}


export function getVehicleTractorId(vehicle) {
  const slot = getBindingSlot(vehicle);
  if (slot && slot.tractor_unit) {
    return slot.tractor_unit.id;
  }
  if (vehicle && vehicle.detail) {
    return vehicle.detail.id;
  }
  return null;
}


export function getBindingScheduleId(slot) {
  if (!slot || slot.schedule == null) {
    return null;
  }
  return typeof slot.schedule === 'object' ? slot.schedule.id : slot.schedule;
}


export function findBindingForVehicle(results, vehicle) {
  const slot = getBindingSlot(vehicle);
  const tractorId = getVehicleTractorId(vehicle);
  const scheduleId = getBindingScheduleId(slot);

  return (results || []).find(item => {
    const start = item.start_slot;
    if (!start) {
      return false;
    }
    const itemScheduleId = getBindingScheduleId(start);
    if (scheduleId && itemScheduleId === scheduleId) {
      return true;
    }
    return tractorId && start.tractor_unit && start.tractor_unit.id === tractorId;
  });
}


export function changeOrderBinding(order, vehicle) {
  const slot = getBindingSlot(vehicle);
  return axios.get(`planning/${order.id}`).then((res) => {
    const item = res.data;
    item.schedule = slot.schedule;
    item.driver = slot.driver || null;
    item.tractor_unit = slot.tractor_unit || null;
    item.semi_trailer = slot.semi_trailer || null;
    return axios.put(`planning/${order.id}`, item);
  });
}


export function clearOrderBinding(order) {
  return axios.get(`planning/${order.id}`).then((res) => {
    const item = res.data;
    item.schedule = null;
    item.driver = null;
    item.tractor_unit = null;
    item.semi_trailer = null;
    return axios.put(`planning/${order.id}`, item);
  });
}



export function getOrderTractorUnitId(order) {
  if (!order || !order.tractor_unit) {
    return null;
  }
  return typeof order.tractor_unit === 'object' ? order.tractor_unit.id : order.tractor_unit;
}
